import React, { Component } from 'react';
import { connect } from 'react-redux';
import ContactSearchHit from './ContactSearchHit';

class SearchResults extends Component {
  render() {
    return (
      <div className="contact-search__results">
        <div className="row">
          {this.props.hits.map(hit => {
            return (
              <div className="col-lg-6" key={hit.id}>
                <ContactSearchHit hit={hit} translations={this.props.translations} />
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    hits: state.results.hits,
    translations: state.translations,
  };
}

export default connect(mapStateToProps)(SearchResults);
